import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../../components/Component";

const ReceivablesAside = ({ updateSm, sm }: any) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  const flowType = searchParams.get("flowType");
  const flowTypeQuery = flowType ? `?flowType=${flowType}` : "";

  const isActive = (path: string) => {
    return currentPath.includes(path);
  };

  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">Receivables</span>
            <span className="sub-text">
              Manage receivables tracking, collection, and reconciliation
            </span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li className={isActive("/create-receivable") ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/create-receivable`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-circle" />
              <span>Create Receivable</span>
            </Link>
          </li>
          <li className={isActive("/view-receivables") ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/view-receivables${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="list" />
              <span>View Receivables</span>
            </Link>
          </li>
          <li
            className={isActive("/pending-payment-approvals") ? "active" : ""}
          >
            <Link
              to={`${process.env.PUBLIC_URL}/pending-payment-approvals${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-round" />
              <span>Pending Approvals</span>
            </Link>
          </li>
          <li className={isActive("/release-retention") ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/release-retention${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="unlock" />
              <span>Release Retention</span>
            </Link>
          </li>
          <li className={isActive("/release-on-hold") ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/release-on-hold${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="shield-off" />
              <span>Release On Hold</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ReceivablesAside;
